
function toggleMobileNavigation() {
  const menuEl = document.getElementById('mobile_menu')
  const classList =  menuEl.classList 
  
  const isOpen = classList.contains('open')

  if (isOpen) {
    classList.remove('open')
  } else {
    classList.add('open')
  }
}

document.addEventListener('toggleMobileNavigation', toggleMobileNavigation)


// ALL ADD TO CARTS IN PRODUCT CARDS 

async function addItemToCart(e) {
  e.preventDefault()
  const target = e.target
  const button = target.nodeName === 'BUTTON' ? target : target.closest('.add_to_cart_button')

  try {
    const variantId = button.getAttribute('data-variant-id')

    button.classList.add('loading')
    button.setAttribute('disabled', true)

    if (!variantId) return 

    let formData = {
      items: [
        {
          id: parseFloat(variantId),
          quantity: 1
        }
      ]
    }

    await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })

    document.dispatchEvent(new Event('updateCart'))

  } catch (error) {
    console.log('error ->', error)

  } finally {
    button.classList.remove('loading')
    button.removeAttribute('disabled')
  }
}

const bestSellersATC = document.querySelectorAll('.best_seller_item .add_to_cart_button')

bestSellersATC.forEach(function(button) {
  button.addEventListener('click', addItemToCart)
})

const productCardsATC = document.querySelectorAll('.add_to_cart')

productCardsATC.forEach(function(button) {
  button.addEventListener('click', addItemToCart)
})